import { z } from 'zod'

export const EXPIRATION_PRESETS = [
  'never',
  '12h',
  '1d',
  '2d',
  '7d',
  '30d',
  'custom',
] as const

export type ExpirationPreset = (typeof EXPIRATION_PRESETS)[number]

const resourceScopingSchema = z
  .record(
    z.string(),
    z.object({ mode: z.enum(['all', 'specific']), ids: z.array(z.string()) })
  )
  .optional()

export const createApiKeySchema = z
  .object({
    name: z.string().min(1, 'Name is required'),
    expirationPreset: z.enum(EXPIRATION_PRESETS).default('never'),
    expiredAt: z.date().nullish(),
    permissionMode: z.enum(['role', 'custom']).default('role'),
    idRole: z.string().default(''),
    capabilities: z.array(z.object({ permission: z.string() })).default([]),
    resourceScoping: resourceScopingSchema,
  })
  .refine(
    (values) =>
      values.expirationPreset !== 'custom' || values.expiredAt !== null,
    {
      message: 'Expiration date is required',
      path: ['expiredAt'],
    }
  )
  .refine(
    (values) =>
      (values.permissionMode === 'role' && values.idRole.length > 0) ||
      (values.permissionMode === 'custom' && values.capabilities.length > 0),
    {
      message: 'Select a role or at least one capability',
      path: ['idRole'],
    }
  )

export type CreateApiKeyFormValues = z.input<typeof createApiKeySchema>
